import { Card, Flex, Icon, Text, Tooltip } from '@lego/klik-ui';
import { PlusBold } from '@lego/klik-ui/icons';

type Props = {
  onClick: () => void;
};

export const CreateWorkspaceCard = (props: Props) => {
  return (
    <Tooltip label="Create a new workspace" placement="bottom">
      <Card
        _hover={{ borderColor: 'slate.400', color: 'slate.600' }}
        alignItems="center"
        borderColor="slate.300"
        borderStyle="dashed"
        borderWidth="2px"
        boxShadow="none"
        color="slate.500"
        cursor="pointer"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        onClick={props.onClick}
        px={8}
        py={5}
        rounded="md"
        width="md"
      >
        <Flex alignItems="center" flexDirection="column" gap={2}>
          <Icon as={PlusBold} boxSize={8} />
          <Text fontWeight="bold">Create New</Text>
        </Flex>
      </Card>
    </Tooltip>
  );
};
